import { PaginationFilterRequest } from "./core.model";
import { City } from "./city.model";
import { ClubTag } from "./club-tag.model";

export enum ClubVisibilityEnum {
  Public = 1,
  Private = 2,
}

export const ClubVisibilityList = [
  { value: 1, label: "Public" },
  { value: 2, label: "Private" },
];

export enum ClubJoinTypeEnum {
  /** Club has no Owner. Nobody can join. Set by the API, never chosen here. */
  NotOwned = 1,
  Auto = 2,
  Manual = 3,
}

/** NotOwned is deliberately absent: it is implied by having no Owner and is set
 *  only by the API. Offering it here would let an admin strand a club. */
export const ClubJoinTypeSelectableList = [
  { value: 2, label: "Auto" },
  { value: 3, label: "Manual" },
];

/** Full list including NotOwned, for read-only display in lists. */
export const ClubJoinTypeDisplayList = [
  { value: 1, label: "Not owned" },
  { value: 2, label: "Auto" },
  { value: 3, label: "Manual" },
];

export enum ClubStatusEnum {
  Draft = 1,
  Active = 2,
  Archived = 3,
}

export const ClubStatusList = [
  { value: 1, label: "Draft" },
  { value: 2, label: "Active" },
  { value: 3, label: "Archived" },
];

export interface RunningClub {
  id: number;
  name: string;
  description: string;
  cityId: number;
  city: City;
  logoUrl?: string;
  /** Ordered brand colors ("#RRGGBB"/"#RRGGBBAA"). Null/absent when never configured. */
  brandColors?: string[];
  priority?: number;
  visibility: ClubVisibilityEnum;
  joinType: ClubJoinTypeEnum;
  status: ClubStatusEnum;
  /** Read-only. Allocated on creation, changed only via the rotate endpoint. */
  privateJoinKey: string;
  ownerUserId?: number;
  tags: ClubTag[];
}

export interface RunningClubList {
  id: number;
  name: string;
  description: string;
  cityId: number;
  city: City;
  logoUrl?: string;
  priority?: number;
  visibility: ClubVisibilityEnum;
  joinType: ClubJoinTypeEnum;
  status: ClubStatusEnum;
}

export interface UpsertRunningClub {
  id?: number;
  name?: string;
  description?: string;
  logoUrl?: string;
  /** Ordered brand colors, max 8. An empty array is normalized to null server-side. */
  brandColors?: string[];
  cityId?: number;
  priority?: number;
  // These three are REQUIRED by the API. It carries [EnumDataType] on each, and
  // ASP.NET binds an omitted non-nullable enum to 0, which fails validation with
  // a 400. Never send them undefined.
  visibility: ClubVisibilityEnum;
  joinType: ClubJoinTypeEnum;
  status: ClubStatusEnum;
  /** The club's full tag set — replaces the existing tags. Omit to leave tags unchanged. */
  tagIds?: number[];
  // privateJoinKey is deliberately absent — the API ignores it on upsert.
}

export interface AssignClubOwner {
  runningClubId: number;
  userId: number;
}

export class RunningClubPaginationFilterRequest extends PaginationFilterRequest {
  cityId?: number;
  visibility?: ClubVisibilityEnum;
  status?: ClubStatusEnum;
}
